<template>
  <div class="word-list12">
    <div
      class="head"
      :style="{
        backgroundImage: 'url(' + dataInfo.cover + ')'
      }"
    >
      {{ dataInfo.name }}
    </div>
    <div class="g-box">
      <div class="content">
        <div class="con-le">
          <img class="img" :src="dataList.image" alt="" />
        </div>
        <div class="con-ri" v-html="dataList.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";

export default {
  data() {
    return {
      query: this.$route.query,
      dataInfo: {},
      dataList: []
    };
  },
  mixins: [pageMain_mx],
  components: {},
  mounted() {},
  methods: {
    async init() {
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 999,
        menuId: this.query.id
      });
      const dataInfo = await this.getMenuInfo(this.query.id);
      this.dataInfo = dataInfo;
      this.dataList = data[0];
      console.log(this.dataList, "dataList");
    }
  }
};
</script>
<style lang="less">
.word-list12 {
  .head {
    height: 280px;
    // width: 1920px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 60px;
    color: #fff;
    letter-spacing: 40px;
  }
  .content {
    padding-top: 60px;
    padding-bottom: 120px;
    display: flex;
    .con-le {
      margin-right: 20px;
      width: 820px;
      height: 520px;
      .img {
        display: block;
        width: 820px;
        height: 520px;
      }
    }
    .con-ri {
      padding: 30px 40px;
      background-color: #eef3fa;
    }
  }
}
</style>
